import {atom} from "recoil";

type AlertType = {
  toggle: boolean;
  message: string;
  execution: () => void;
};
type ExtraAlertType = {
  title?: string;
  toggle: boolean;
  message: string;
};

export const alertStateAtom = atom<AlertType>({
  key: "alertState",
  default: {
    toggle: false,
    message: "",
    execution: () => {},
  },
});
export const extraAlertStateAtom = atom<ExtraAlertType>({
  key: "extraAlertStateAtom",
  default: {
    title: "",
    toggle: false,
    message: "",
  },
});
export const alertToggleState = atom<boolean>({
  key: "alertToggle",
  default: false,
});
export const alertPermitState = atom<boolean>({
  key: "alertPermit",
  default: false,
});
export const alertIdState = atom<number>({
  key: "alertId",
  default: 0,
});
export const alertMessageState = atom<string>({
  key: "alertMessage",
  default: "",
});
export const alertExecutionState = atom<any>({
  key: "alertExecution",
  default: undefined,
});
